import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
export const Definition = (props) => {
  return (
    <div>
      <h2 className="alert-warning text-center">
        Some Definition of &nbsp;
        <span style={{ color: "green", textDecoration: "underline " }}>
          {props.custom}
        </span>
        &nbsp; are :
      </h2>

      {props.sale?.[0]?.map((e) => {
        return (
          <p
            style={{
              fontFamily: "Sofia,sans-serif",
              fontSize: "30px",
              textShadow: "3px 3px 3px #ababab",
            }}
            key={e}
          >
            <RadioButtonCheckedIcon /> {e}
          </p>
        );
      })}
    </div>
  );
};
